/**
 * 管理后台应用入口(Vue 3)
 * 主题:营养绿(UX-v0.1 候选 A)
 * 引入顺序:
 *   1. Element Plus 默认 CSS(后被 element-overrides 覆盖)
 *   2. element-overrides.scss(SCSS 变量覆盖主色)
 *   3. prototype.css(项目级共享样式 + CSS 变量)
 */

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import './styles/element-overrides.scss';
import './styles/prototype.css';
import App from './App.vue';
import { router } from './router';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(ElementPlus);
app.mount('#app');
